// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"footerWrapper___28SGr","btn":"btn___30I5v"};